import React, { useState } from "react";
import useForm from '../../../hooks/useForm';
import useFetch from '../../../hooks/useFetch'
import { FormField,  Modal, Button } from '@prosolve/common-components-ui'
// import useDataAttendees from "../../../../dataHooks/useDataAttendees";
import { getClientSubdomain } from '../../../utils';
import FormFieldUsStates from "../../../shared/FormFieldUsStates";

export default ({
  eventData = {},
  onClose,
  onSuccess,
}) => {
  const clientSubdomain = getClientSubdomain()
  const isStarSubdomain = (clientSubdomain === 'star')

  const optionalFields = ['projectAssessmentName', 'description', 'eventBlueprintDocument', 'internalPlanningGuideLink', 'slideDeckLink', 'addressStreet', 'addressCity', 'addressState', 'addressZip', 'additionalLocationNotes', 'projectHandoutsLink'];
  if (isStarSubdomain) {
    optionalFields.push('numberOfParticipants')
    optionalFields.push('customerSuccessNotes')
    optionalFields.push('logisticsStatus')
  }

  const formSchema = {
    requiredFields: ['name'],
    optionalFields,
    initData: eventData
  };

  const formData = useForm(formSchema)

  const [isBusy, setIsBusy] = useState(false);

  const fetch = useFetch()

  const onClickSubmit = async () => {
    if (!isBusy && formData.isValid()) {
      setIsBusy(true)

      try {
        const response = await fetch(`events/event/update`, {
          method: 'POST',
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ data: { ...formData.values, id: eventData.id } })
        })
        const jsonData = await response.json()

        if (jsonData.success) {
          setIsBusy(false)
          onSuccess()
        }
      } catch (e) {
        console.log(e)
      }

      setIsBusy(false)

      onClose()
    }
  }

  const footer = (
    <div style={{ 
      display: 'flex',
      justifyContent: 'flex-end',
      alignItems: 'center',
      columnGap: '10px',
      padding: '10px'
    }}>
      <Button onClick={onClose}>
        {'Cancel'}
      </Button>
      <Button onClick={onClickSubmit} $colored={true} $disabled={isBusy}>
        {'Submit'}
      </Button>
    </div>
  )

  return (
    <Modal title={'Edit Event'} isAutoHeight={true} onClose={onClose} footer={footer}>
      <div style={{
        display: 'flex',
        flexDirection: 'column',
        rowGap: '15px'
      }}>
        <FormField
          style={{ flex: 1 }}
          fieldId='name'
          type='text'
          label='Name'
          placeholder=''
          formData={formData}
        />
        <FormField
          style={{ flex: 1 }}
          fieldId='description'
          type='textarea'
          label='Description'
          placeholder=''
          formData={formData}
        />
        <FormField
          style={{ flex: 1 }}
          fieldId='eventBlueprintDocument'
          type='text'
          label='Event Document Link'
          placeholder=''
          formData={formData}
        />
        {
          !isStarSubdomain &&
          <FormField
            style={{ flex: 1 }}
            fieldId='internalPlanningGuideLink'
            type='text'
            label="Internal Planning Guide Link"
            placeholder=''
            formData={formData}
          />
        }
        <FormField
          style={{ flex: 1 }}
          fieldId='slideDeckLink'
          type='text'
          label="Slide Deck Link"
          placeholder=''
          formData={formData}
        />

        <div>
          <div style={{ color: '#565656', fontWeight: 'bold', fontSize: '14px', marginBottom: '10px' }}>{'Address'}</div>
          <div style={{
            display: 'flex',
            flexDirection: 'column',
            rowGap: '15px',
            background: '#fdfdfd',
            border: '1px solid #dedede',
            borderRadius: '5px',
            padding: '13px'
          }}>
            <FormField
              style={{ flex: 1 }}
              fieldId='addressStreet'
              type='text'
              label='Street'
              placeholder=''
              formData={formData}
            />
            <FormField
              style={{ flex: 1 }}
              fieldId='addressCity'
              type='text'
              label='City'
              placeholder=''
              formData={formData}
            />
            <FormFieldUsStates
              style={{ flex: 1 }}
              fieldId='addressState'
              label='State'
              placeholder=''
              formData={formData}
              width='100%'
              maxHeight='300px'
            />
            <FormField
              style={{ flex: 1 }}
              fieldId='addressZip'
              type='text'
              label='Zip'
              placeholder=''
              formData={formData}
            />
          </div>
        </div>

        <FormField
          style={{ flex: 1 }}
          fieldId='additionalLocationNotes'
          type='text'
          label="Additional Location Notes"
          placeholder=''
          formData={formData}
        />

        {
          isStarSubdomain &&
          <FormField
            style={{ flex: 1 }}
            fieldId='numberOfParticipants'
            type='number'
            label="Number Of Participants"
            placeholder=''
            formData={formData}
          />
        }

        {
          isStarSubdomain &&
          <FormField
            style={{ flex: 1 }}
            fieldId='customerSuccessNotes'
            type='richtext'
            label="Trainer Prep: Event Context"
            placeholder=''
            formData={formData}
          />
        }

        {
          isStarSubdomain &&
          <FormField
            style={{ flex: 1 }}
            width="100%"
            fieldId='logisticsStatus'
            type='select'
            label='Logistics Status'
            options={[
              { text: '', value: ''}, 
              { text: 'In Progress', value: 'In Progress'}, 
              { text: 'Complete', value: 'Complete'}
            ]}
            formData={formData}
          />
        }

        {
          isStarSubdomain &&
          <FormField
            style={{ flex: 1 }}
            fieldId='projectHandoutsLink'
            type='text'
            label="Handouts Link"
            placeholder=''
            formData={formData}
          />
        }

        <FormField
          style={{ flex: 1 }}
          fieldId='projectAssessmentName'
          type='text'
          label='Assessment Name'
          placeholder=''
          formData={formData}
        />

      </div>
    </Modal>
  )
}